import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import DashboardCard from './DashboardCard';
import {
  StatValue, StatSub, ProgressTrack, ProgressFill,
} from '../styles';

// SuccessionCoverage — "aktif" kritik pozisyonlar arasında en az bir ready_6m
// adayı olanların oranı (bkz. backend TalentDashboardDataAccess.
// ComputeSuccessionCoverageAsync yorumu — succession-risk raporunun TERSİ
// bakış açısı, AYNI kapsam).
export default function SuccessionCoverageCard({ coverage, loading }) {
  const { t } = useTranslation();
  const theme = useTheme();

  const empty = !coverage || coverage.activePositionCount === 0;

  return (
    <DashboardCard
      title={t('talent.dashboard.succession.title')}
      span={4}
      spanMd={6}
      loading={loading}
      empty={empty}
      emptyText={t('talent.dashboard.succession.empty')}
    >
      {coverage && (
        <div>
          <StatValue>{coverage.coveragePercent}%</StatValue>
          <StatSub>
            {t('talent.dashboard.succession.covered', {
              covered: coverage.readyCoveredPositionCount,
              total: coverage.activePositionCount,
            })}
          </StatSub>
          <ProgressTrack style={{ marginTop: 10 }}>
            <ProgressFill $pct={coverage.coveragePercent} $color={theme.colors.secondary.dark} />
          </ProgressTrack>
        </div>
      )}
    </DashboardCard>
  );
}
